import axios from 'axios'
import {
    CADASTRAR_USUARIOS_EMPRESA_EM_LOTE,
    LIMPAR_RETORNO_CADASTRAMENTO_USUARIO_EMPRESA_EM_LOTE,
    HABILITADO_PAGAMENTO_POS, HABILITADO_PAGAMENTO_TEF
} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export function cadastrarUsuariosEmpresaEmLote(parametros) {
    const url = `${URL}/usuarios-empresa/cadastrar-em-lote`;
    return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: CADASTRAR_USUARIOS_EMPRESA_EM_LOTE,
            payload: response
        })
    );
}

export function usuarioEmpresaHabilitadoPagamentoViaPOS(idEmpresa) {
    const url = `${URL}/usuarios-empresa/empresa/${idEmpresa}/habilitado-pagamento-via-pos`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: HABILITADO_PAGAMENTO_POS,
            payload: response
        })
    );
}

export function usuarioEmpresaHabilitadoPagamentoViaTEF(idEmpresa) {
    const url = `${URL}/usuarios-empresa/empresa/${idEmpresa}/habilitado-pagamento-via-tef`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: HABILITADO_PAGAMENTO_TEF,
            payload: response
        })
    );
}

export function limparRetornocadastramentoUsuariosEmpresaEmLote() {
    return {
        type: LIMPAR_RETORNO_CADASTRAMENTO_USUARIO_EMPRESA_EM_LOTE
    }
}

